import { makeStyles } from "@mui/styles";

const StyleTermo = makeStyles((theme) => ({
   container: {
padding:0
   }
}));

export default StyleTermo;